import React from "react";
import "./Legal.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "@fortawesome/fontawesome-free/css/all.min.css";

// Import documents from assets
import TermsConditions from "../assets/Terms-Conditions-Globus-Trading.docx";
import KYCPolicy from "../assets/KYC-Policy.docx";
import RiskDisclosure from "../assets/Risk-Disclosure-Statement.docx";
import AMLPolicy from "../assets/AML-Policy-Globus-Trading.docx";
import PrivacyPolicy from "../assets/PRIVACY-POLICY.docx";

const Legal = () => {
  const legalDocuments = [
    { title: "Terms & Condition", fileUrl: TermsConditions },
    { title: "KYC Policy", fileUrl: KYCPolicy },
    { title: "Risk Disclosure", fileUrl: RiskDisclosure },
    { title: "AML Policy", fileUrl: AMLPolicy },
    { title: "Privacy Policy", fileUrl: PrivacyPolicy },
  ];

  // Function to trigger file download
  const handleDownload = (fileUrl: string, fileName: string) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Navbar />

      <div className="legal-section">
        <h2 className="legal-title">Legal Documents</h2>
      </div>

      <div className="below-hero-section2">
        <h2>Explore Our Legal Resources</h2>
        <p>
          Ensure your peace of mind with easy access to our comprehensive legal documents.
          From Terms of Service to Privacy Policies, we’ve got you covered. Navigate our legal landscape with confidence and clarity.
        </p>
      </div>

      <div className="legal-container">
        {legalDocuments.map((doc, index) => (
          <div
            key={index}
            className={`legal-box ${index < 3 ? "top-row" : "bottom-row"}`}
            onClick={() => handleDownload(doc.fileUrl, doc.title + ".docx")}
          >
            <i className="fas fa-download"></i>
            <p>{doc.title}</p>
          </div>
        ))}
      </div>

      <Footer />
    </>
  );
};

export default Legal;
